<div class="ci-card">
  <div class="ci-work">
    <textarea class="ci-editor" [value]="state.code" (input)="onCode( $any( $event.target ).value )" (keydown)="onEditorKey( $event )"
              spellcheck="false" autocomplete="off" autocapitalize="off" wrap="off"
              placeholder="Paste your code here" aria-label="Your code"></textarea>
    <div class="ci-preview" #previewWell [class.ci-preview-clear]="state.backdrop === 'none'" [class.ci-preview-tall]="tallPreview">
      <canvas #preview class="ci-canvas" role="img" [attr.aria-label]="'Your ' + state.language.label + ' code in the ' + state.theme.name + ' theme'"></canvas>
      <!-- the well is a preview only; the picture at full size and its download are in the tool's Preview section -->
      <button type="button" class="ci-preview-badge" (click)="previewClick.emit()">Preview</button>
    </div>
  </div>

  <div class="ci-controls">
    <label class="ci-field">
      <span class="ci-label">Language</span>
      <select class="ci-input ci-select" (change)="setLanguage( $any( $event.target ).value )" aria-label="Language">
        <option *ngFor="let l of LANGUAGES" [value]="l.key" [selected]="l.key === state.language.key">{{ l.label }}</option>
      </select>
    </label>
    <!-- the theme as the tools' visual picker (owner 2026-10-13): each theme with its own icon and its five colours,
         in the Appearance menu's order -->
    <div class="ci-field ci-theme-pick">
      <span class="ci-label">Theme</span>
      <button type="button" class="ps-gen-btn" [class.open]="themeOpen" (click)="toggleThemePick( $any( $event.currentTarget ) )"
              aria-haspopup="dialog" [attr.aria-expanded]="themeOpen">
        <img class="ci-theme-logo" [src]="THEME_LOGOS[ state.theme.key ]" alt="" aria-hidden="true"/>
        <span class="ps-gen-text">
          <span class="ps-gen-name">{{ state.theme.name }}</span>
          <span class="ps-theme-colors" *ngIf="THEME_COLORS[ state.theme.key ]?.length" aria-hidden="true"><i *ngFor="let col of THEME_COLORS[ state.theme.key ]" [style.background]="col"></i></span>
        </span>
        <app-icon class="ps-gen-caret" name="chevron-right" aria-hidden="true"></app-icon>
      </button>
      <div class="ps-gen-pop" *ngIf="themeOpen" role="dialog" aria-label="Themes" [style.max-height.px]="themeMaxHeight" (click)="$event.stopPropagation()">
        <ng-container *ngFor="let line of THEME_GROUPS">
          <p class="ci-theme-group">{{ line.name }}</p>
          <ng-container *ngFor="let group of line.minor">
            <p class="ci-theme-group ci-theme-minor">{{ group.name }}</p>
            <button type="button" class="ps-gen-opt" *ngFor="let t of group.themes" [class.on]="t.key === state.theme.key" (click)="pickTheme( t.key )">
              <img class="ci-theme-logo" [src]="THEME_LOGOS[ t.key ]" alt="" aria-hidden="true" loading="lazy"/>
              <span class="ps-gen-text">
                <span class="ps-gen-name">{{ t.name }}</span>
                <span class="ps-theme-colors" *ngIf="THEME_COLORS[ t.key ]?.length" aria-hidden="true"><i *ngFor="let col of THEME_COLORS[ t.key ]" [style.background]="col"></i></span>
              </span>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <label class="ci-field">
      <span class="ci-label">Backdrop</span>
      <select class="ci-input ci-select" (change)="setBackdrop( $any( $event.target ).value )" aria-label="Backdrop">
        <option *ngFor="let b of BACKDROPS" [value]="b.key" [selected]="b.key === state.backdrop">{{ b.label }}</option>
      </select>
    </label>
    <label class="ci-field">
      <span class="ci-label">Padding</span>
      <select class="ci-input ci-select" (change)="setPadding( $any( $event.target ).value )" aria-label="Padding">
        <option *ngFor="let p of PADDINGS" [value]="p" [selected]="p === state.padding">{{ p }} px</option>
      </select>
    </label>
    <label class="ci-field ci-field-title">
      <span class="ci-label">Title</span>
      <input type="text" class="ci-input" [value]="state.title" (input)="setTitle( $any( $event.target ).value )" [disabled]="!state.windowBar"
             maxlength="60" spellcheck="false" autocomplete="off" aria-label="Title">
    </label>
    <div class="ci-field ci-field-toggles">
      <span class="ci-label">Show</span>
      <div class="ci-toggles">
        <button type="button" class="cp-std-btn ci-toggle" [class.on]="state.windowBar" [attr.aria-pressed]="state.windowBar" (click)="toggleWindowBar()">Window Bar</button>
        <button type="button" class="cp-std-btn ci-toggle" [class.on]="state.lineNumbers" [attr.aria-pressed]="state.lineNumbers" (click)="toggleLineNumbers()">Line Numbers</button>
        <!-- Prettify: the code formatted by Prettier, for the languages it knows (owner 2026-10-13) -->
        <button type="button" class="cp-std-btn ci-toggle ci-prettify" *ngIf="canPrettify" (click)="prettifyCode()"
                [disabled]="prettifyState === 'busy'">
          {{ prettifyState === 'failed' ? 'Can\'t Format' : prettifyState === 'busy' ? 'Formatting' : 'Prettify' }}
        </button>
      </div>
    </div>
  </div>
</div>
